module.exports = __webpack_public_path__ + "img/cardiff-square.8bd57c47.png";